export const picklistTemplateFormSchema = {
  type: 'object',
  required: ['name'],
  properties: {
    name: { type: 'string', minLength: 6, maxLength: 255 },
  },
};
